import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { optionsType, PredefinedDataTypes } from "../utils/formTypes";
import usePredefinedDataByType from "../customHooks/usePredefinedType";
import {
  FormAutocomplete,
  formClasses,
  labelClasses,
  LabeledAutocomplete,
} from "../styles/AutocompleteStyles";
import { isOptionEqualToValue } from "../utils/UtilFunctions";
interface Props {
  value: string;
  onChange: (newValue: optionsType | null, type: PredefinedDataTypes) => void;
  label: string;
  disabled?: boolean;
  autoFocus?: boolean;
}
const PredefinedUOM = ({
  value,
  onChange,
  label,
  disabled,
  autoFocus,
}: Props) => {
  const [searchData, setSearchData] = useState("");

  const [autoValue, setAutoValue] = useState<optionsType | null>(null);

  const {
    PredefinedData: { dropDown, data, handleScroll },
  } = usePredefinedDataByType(PredefinedDataTypes.GST_UOM, searchData);

  useEffect(() => {
    if (value) {
      const foundValue = dropDown.find(
        ({ value: optionsValue }) => optionsValue === value
      );

      setAutoValue(foundValue ? foundValue : null);
    } else {
      setAutoValue(null);
    }
  }, [searchData, value, data, dropDown]);

  const commonAutocompleteProps = {
    className: label ? labelClasses.inputRoot : formClasses.inputRoot,
    options: dropDown,
    openOnFocus: true,
    ListboxProps: {
      onScroll: handleScroll,
    },
    disabled: disabled,
    onChange: (e: React.SyntheticEvent<Element, Event>, value: unknown) =>
      onChange(value as optionsType, PredefinedDataTypes.GST_UOM),
  };

  const commonTextFieldProps = {
    onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
      setSearchData(e.target.value),
    label: label || "",
    fullWidth: true,
    InputLabelProps: { shrink: label.length > 0 },
    className: label
      ? labelClasses.formControlRoot
      : formClasses.formControlRoot,
  };

  const Autocomplete =
    label.length > 0 ? LabeledAutocomplete : FormAutocomplete;

  return (
    <Autocomplete
      {...commonAutocompleteProps}
      value={autoValue}
      // {...(value ? { value: autoValue } : {})} // Conditional value
      isOptionEqualToValue={(option) =>
        isOptionEqualToValue(option as optionsType, autoValue)
      }
      renderInput={(params) => (
        <TextField {...params} {...commonTextFieldProps} autoFocus />
      )}
    />
  );
};

export default PredefinedUOM;
